import axios from "axios";
const url_collection = [
  process.env.REACT_APP_API_URL,
  "https://amethyst.gistda.or.th/api/v2/",
  "http://172.27.184.102:8100/api/v3/",
];

// this is Production
const API_URL_Local = process.env.REACT_APP_API_OPE;

// const API_URL_Local = "http://172.27.184.102:8123/api/v3/";
const handleError = (error) => {
  if (error.response) {
    // Error จากการตอบกลับของเซิร์ฟเวอร์
    if(error.response.data.error_description){
      throw error.response.data.error_description
    }else{
      throw "respone error"
    }
    
  } else if (error.request) {
    // Error เกิดขึ้นในระหว่าง request ถูกส่งแต่ไม่ได้รับการตอบกลับ
    console.error("Network Error:", error.request);
    //alert("Network error. Please check your internet connection.");
    throw "Request Error"
  } else {
    // Error จากการตั้งค่าหรืออื่น ๆ
    console.error("Error:", error.message);
    
    //alert(error.message);
    throw "Error Message"
  }
};

const DroneAndPilotData = async (operation_start_time, operation_end_time) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "operation/pilot-drone-data",
        {
          operation_start_time,
          operation_end_time,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      return response;
    } catch (error) {
      
      handleError(error)
      throw error.response;
    }
  } else {
    return "Login expire";
  }
};

const CheckPilotAndDroneData = async (
  co_id,
  drone_id,
  dropdown_id,
  purpose
) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    const response = await axios
      .post(
        API_URL_Local + "operation/check-pilot-drone",
        {
          co_id,
          drone_id,
          dropdown_id,
          purpose,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        // console.log(error.response.data.error_description)
        handleError(error)
        throw error.response;
      });
    return response;
  } else {
    return "Login expire";
  }
};

const CheckOperation = async (
  dropdown_id,
  check_type,
  operation_area,
  altitude,
  area_type
) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");

  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "operation/check-operation",
        {
          dropdown_id,
          check_type,
          operation_area,
          altitude,
          area_type,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      return response;
    } catch (error) {
      handleError(error)
      throw error.response.data.error_description;
    }
  } else {
    return "Login expire";
  }
};
const DroneAndPilotDataforUpdate = async (
  operation_id,
  operation_start_time,
  operation_end_time
) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "operation/pilot-drone-data",
        {
          operation_id,
          operation_start_time,
          operation_end_time,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      return response;
    } catch (error) {
      console.log(error.response.data.error_description);
      handleError(error)
      throw error.response;
    }
  } else {
    return "Login expire";
  }
};
const ComfirmOperation = async (data_id) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "operation/confirm-operation",
        {
          data_id,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      return response;
    } catch (error) {
      handleError(error)
      throw error.response;
    }
  } else {
    return "Login expire";
  }
};
const CheckUpdateOperation = async (
  operation_id,
  co_id,
  drone_id,
  dropdown_id,
  purpose,
  operation_area,
  altitude,
  area_type
) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "operation/check-update-operation",
        {
          operation_id,
          co_id,
          drone_id,
          dropdown_id,
          purpose,
          operation_area,
          altitude,
          area_type,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      return response;
    } catch (error) {
      handleError(error)
      throw error.response;
    }
  } else {
    return "Login expire";
  }
};
const ComfirmUpdateOperation = async (data_id) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "operation/confirm-update-operation",
        {
          data_id,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      return response;
    } catch (error) {
      handleError(error)
      throw error.response;
    }
  } else {
    return "Login expire";
  }
};
const FindAgencyOperation = async (operation_code) => {
  const access_token = sessionStorage.getItem("access_token");
  console.log(operation_code);
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "operation/find-agency-operation",
        {
          operation_code,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      return response;
    } catch (error) {
      handleError(error)
      throw error.response;
    }
  } else {
    return "Login expire";
  }
};

const JoinOperation = async (operation_code, dropdown_id, co_id, drone_id) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "operation/join-operation",
        {
          operation_code,
          dropdown_id,
          co_id,
          drone_id,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      return response;
    } catch (error) {
      handleError(error)
      throw error.response;
    }
  } else {
    return "Login expire";
  }
};
const CancelJoinOperation = async (co_id) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "operation/cancel-join-operation",
        {
          operation_co_id: co_id,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );

      return response;
    } catch (error) {
      handleError(error)
      throw error.response;
    }
  } else {
    return "Login expire";
  }
};

const NotificationOperation = async () => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.get(
        API_URL_Local + "operation/notify-operation",
        {
          headers: { Authorization: `Bearer ${access_token}` },
        }
      );
      return response;
    } catch (error) {
      handleError(error)
      throw error.response;
    }
  } else {
    return "Login expire";
  }
};
const UpdateNotificationOperation = async (update_all, noti_id) => {
  const access_token = sessionStorage.getItem("access_token");
  console.log(update_all, noti_id);
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    if (update_all === "y") {
      try {
        const response = await axios.post(
          API_URL_Local + "operation/update-notification",
          {
            update_all: update_all,
            noti_id: "0",
          },
          {
            headers: {
              Authorization: `Bearer ${access_token}`,
            },
          }
        );
        return response;
      } catch (error) {
        handleError(error)
        throw error.response;
      }
    } else {
      try {
        const response = await axios.post(
          API_URL_Local + "operation/update-notification",
          {
            update_all: "n",
            noti_id: noti_id,
          },
          {
            headers: {
              Authorization: `Bearer ${access_token}`,
            },
          }
        );
        console.log(response);
        return response;
      } catch (error) {
        handleError(error)
        throw error.response;
      }
    }
  } else {
    return "Login expire";
  }
};

const ShortestPath = async (
  start_coordinates,
  end_coordinates,
  upper_altitude
) => {
  const access_token = sessionStorage.getItem("access_token");
  const lower_altitude = upper_altitude - 10;
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "operation/shortest-path",
        {
          start_coordinates,
          end_coordinates,
          lower_altitude,
          upper_altitude,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      return response;
    } catch (error) {
      handleError(error)
      throw error.response.data.error_description;
    }
  } else {
    return "Login expire";
  }
};

const RealTimeDrone = async (remote_id_sn) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "operation/drone-data-from-rid",
        {
          remote_id_sn,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      return response;
    } catch (error) {
      handleError(error)
      throw error.response.data.error_description;
    }
  } else {
    return "Login expire";
  }
};

const Getfile = async (filename) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.get(
        API_URL_Local + "operation/conditiondoc/file",
        {
          responseType: "blob",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${access_token}`,
          },
          params: {
            filename,
          },
        }
      );
      return response;
    } catch (error) {  
      handleError(error)
      throw error.response.data.error_description;
    }
  }
};

const AuthServiceV2 = {
  DroneAndPilotData,
  CheckPilotAndDroneData,
  DroneAndPilotDataforUpdate,
  CheckOperation,
  ComfirmOperation,
  CheckUpdateOperation,
  ComfirmUpdateOperation,
  FindAgencyOperation,
  JoinOperation,
  NotificationOperation,
  UpdateNotificationOperation,
  CancelJoinOperation,
  ShortestPath,
  RealTimeDrone,
  Getfile,
};

export default AuthServiceV2;
